/**
 * Shared Framer Motion animation variants for scroll-triggered ease-in effects.
 * Use with `whileInView`, `initial`, and `viewport={{ once: true }}`.
 */

const ease = [0.25, 0.46, 0.45, 0.94];

/** Fade + slide up — default for most elements */
export const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease },
  },
};

/** Fade in only — subtle, for images / backgrounds */
export const fadeIn = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { duration: 0.7, ease },
  },
};

/** Fade + slide from left */
export const fadeLeft = {
  hidden: { opacity: 0, x: -40 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.65, ease },
  },
};

/** Fade + slide from right */
export const fadeRight = {
  hidden: { opacity: 0, x: 40 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.65, ease },
  },
};

/** Stagger container — wraps children that stagger one-by-one */
export const staggerContainer = (staggerChildren = 0.12, delayChildren = 0.1) => ({
  hidden: {},
  show: {
    transition: {
      staggerChildren,
      delayChildren,
    },
  },
});

/** Scale + fade — for cards that "pop" in */
export const scaleFade = {
  hidden: { opacity: 0, scale: 0.92 },
  show: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.55, ease },
  },
};

/** Default viewport config — animate once, trigger when 15% visible */
export const viewport = { once: true, amount: 0.15 };
